import React, { FC } from 'react';

import StatusTooltip, { StatusTooltipProps } from '../StatusTooltip';
import InfoButton from '../../buttons/InfoButton';

export interface InfoTooltipProps extends Omit<StatusTooltipProps, 'CustomButton'> {}

const InfoTooltip: FC<InfoTooltipProps> = (({ ...props }) => (
  <StatusTooltip
    data-testid="InfoTooltip"
    CustomButton={InfoButton}
    {...props}
  />
));

export default InfoTooltip;
